import styles from '../styles.module.css';

const MissionCompleteDay = ({dayCount, isDone, dateString}) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}/${day}`;
  }

  return (
    <li className={isDone ? styles.done : undefined}>
      <span className={styles.label_day}>DAY {dayCount}</span>
      <span className={styles.label_done}>완료!</span>
      <div className={styles.stamp}>
        <span className={styles.date}>{formatDate(dateString)}</span>
      </div>
    </li>
  );
};

export default MissionCompleteDay;
